import script from "./clinic-users.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-users.vue?vue&type=script&setup=true&lang=js"

import "./clinic-users.vue?vue&type=style&index=0&id=e9f171ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9f171ea"]])

export default __exports__